/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbSupportNumber_viewer$ref: FragmentReference;
export type PdpSharedBlurbSupportNumber_viewer = {|
  +isEnabled: ?boolean,
  +contactInfo: ?{|
    +phoneNumbers: ?{|
      +support: ?string
    |}
  |},
  +$refType: PdpSharedBlurbSupportNumber_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbSupportNumber_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "PDP_SUPPORT_NUMBER_BLURB",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"PDP_SUPPORT_NUMBER_BLURB\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "contactInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "ContactInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "phoneNumbers",
          "storageKey": null,
          "args": null,
          "concreteType": "support",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "support",
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "INTERNATIONAL",
                  "type": "formatPhoneNumberTypes"
                }
              ],
              "storageKey": "support(formatType:\"INTERNATIONAL\")"
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '500246412867f3f2b0fd4c36ab4a2fdf';
module.exports = node;
